module.exports = __webpack_public_path__ + "static/media/new-members_top_min.944c1eaf.jpg";